import { render } from "./outboundOrder.vue?vue&type=template&id=234c48ac&scoped=true"
import script from "./outboundOrder.vue?vue&type=script&lang=js"
export * from "./outboundOrder.vue?vue&type=script&lang=js"

import "./outboundOrder.vue?vue&type=style&index=0&id=234c48ac&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234c48ac"]])

export default __exports__